
import { useEffect } from 'react'
import Select from 'react-select'
import { MainFeederLocationDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const MainFeederLocationDataDDL = (props) => {
    const { MainFeederLocationDDL, setMainFeederLocationDDL, CropNameDashboardData, PopUpField,IsPost,WardName } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            // M_WardID: '1',
            M_UserID: UserID,
            token: token,
            WardName:WardName.ID
        }
        dispatch(MainFeederLocationDDLAPI({ data }))
    }, [IsPost,WardName.ID])

    const { MainFeederLocationData } = useSelector(state => state.MainFeederLocationDDLData)

    useEffect(() => {
        handleLocationNameDDL()
    }, [MainFeederLocationData])

    const handleLocationNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (MainFeederLocationData && MainFeederLocationData.table && MainFeederLocationData.table.length > 0) {
            let list = MainFeederLocationData.table.map((item, index) => ({
                value: item.m_Distri_WS_LocationID,
                label: item.locationDetails,
            }))

            setMainFeederLocationDDL({
                DDL: list,
                ID: 0,
                Label: "Select...",
            })
        }
        else {
            setMainFeederLocationDDL({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Location Name </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width3"
                isSearchable
                maxMenuHeight={150}
                value={{ value: MainFeederLocationDDL.ID, label: MainFeederLocationDDL.Label }}
                onChange={(e) => {
                    e ?
                        setMainFeederLocationDDL({ ...MainFeederLocationDDL, ID: e.value, Label: e.label })
                        :
                        setMainFeederLocationDDL({ ...MainFeederLocationDDL, ID: 0, Label: "Select..." })

                }}
                options={MainFeederLocationDDL.DDL}
            />
        </div>
    )
}